import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EmployeeState } from './employee.reducer';
import { ROLES_NAME } from '@core/interface/employee';

export const selectDataState = createFeatureSelector<EmployeeState>('Employee');

export const getEmployeeData = createSelector(
  selectDataState,
  (state: EmployeeState) => state
);
export const getLoadingState = createSelector(
  selectDataState,
  (state: EmployeeState) => state.isLoading
);

export const getDeletedStatus = createSelector(
  selectDataState,
  (state: EmployeeState) => state.isDeleted
);

export const getLoadError = createSelector(
  selectDataState,
  (state: EmployeeState) => state.loadError
);
export const getDeleteError = createSelector(
  selectDataState,
  (state: EmployeeState) => state.deleteError
);
export const getAddEditError = createSelector(
  selectDataState,
  (state: EmployeeState) => state.addEditError
);

export const getInviteLoading = createSelector(
  selectDataState,
  (state: EmployeeState) => state.inviteLoading
);
export const getInviteError = createSelector(
  selectDataState,
  (state: EmployeeState) => state.inviteError
);
export const getInviteSuccess = createSelector(
  selectDataState,
  (state: EmployeeState) => state.isInvited
);

export const getInviteResponse = createSelector(
  selectDataState,
  (state: EmployeeState) => state.inviteResponse
);

export const getEmployeeByRole = (roleName: ROLES_NAME) =>
  createSelector(selectDataState, (state) => state.employeeByRole[roleName]);

export const getUserProfile = createSelector(
  selectDataState,
  (state: EmployeeState) => state.userProfile
);

export const getPasswordChangedStatus = createSelector(
  selectDataState,
  (state: EmployeeState) => state.isPasswordChanged
);

export const getPasswordChangedLoadingStatus = createSelector(
  selectDataState,
  (state: EmployeeState) => state.isPasswordChangedLoading
);

export const getEmployeeByRoleLoading = createSelector(
  selectDataState,
  (state: EmployeeState) => state.isEmployeeByRoleLoading
);

export const getEmploymentTypeData = createSelector(
  selectDataState,
  (state: EmployeeState) => state.employmentType
);

export const getWorkScheduleData = createSelector(
  selectDataState,
  (state: EmployeeState) => state.workSchedule
);

export const getWorkLocationData = createSelector(
  selectDataState,
  (state: EmployeeState) => state.workLocation
);
